export default __webpack_public_path__ + "static/media/gallery_01.47c6e3ac.jpg";